import type { Petition } from './types';

/**
 * The single definition of "the petition has a displayable cover image" on this page: returns the
 * renditions to render, or `undefined` when there is no photo or either rendition is still processing
 * or has no url.
 *
 * Shared by usePetitionMedia and both normalizers' `hideMediaSlot` (normalizeData and
 * normalizeSocialStarterData) so they can never disagree about what counts as "no displayable cover image".
 */
export function getDisplayablePetitionPhoto(photo: Petition['photo']): { url: string; mobileUrl: string } | undefined {
	const photoUrl = !photo?.petitionMedium.processing ? photo?.petitionMedium.url : undefined;
	const photoMobileUrl = !photo?.petitionSmall.processing ? photo?.petitionSmall.url : undefined;

	return photoUrl && photoMobileUrl
		? {
				url: photoUrl,
				mobileUrl: photoMobileUrl,
			}
		: undefined;
}
